import { message } from "antd";
import { callApi } from "./callApi";
import WeaLocaleProvider from "../wea-locale-provider";

const getLabel = WeaLocaleProvider.getLabel;

export const checkJoin = () => {
  if (window.emJoinStatus) {
    // return window.emJoinStatus;
    return new Promise((rs, rj) => {
      rs(window.emJoinStatus);
    });
  } else {
    return callApi("/api/ec/dev/app/checkJoin", "GET", {}).then(res => {
      if (res.status == true) {
        window.emJoinStatus = res;
        return window.emJoinStatus;
      } else {
        window.emJoinStatus = {
          status: false,
          joinStatus: false,
          emSwitch: "0",
          shareSwitch: "0",
          webSwitch: "0",
          wxWorkShareSwitch: "0",
          dingTalkShareSwitch: "0"
        };
        return window.emJoinStatus;
      }
    });
  }
};
checkJoin();

window.em_checkJoin = checkJoin;

// 调用em语音视频功能
export const getEmAudioOrVideo = (id, type, callback) => {
  if (window.customEmAudioOrVideo) {
    window.customEmAudioOrVideo(id, type);
  } else {
    const params = {
      touserids: id,
      msginfo: [
        {
          objectName: "FW:VideoMsg",
          type //1表示音频，2表示视频
        }
      ]
    };
    callApi("/api/ec/dev/share/openConversation", "POST", {
      data: JSON.stringify(params)
    }).then(result => {
      if (result.status && result.data.errcode === 0) {
        callback(result);
      } else {
        message.error(
          result.data && result.data.errmsg
            ? result.data.errmsg
            : getLabel("515835", "调用em接口失败")
        );
      }
    });
  }
};

// 判断是否显示ding
export const checkDing = () => {
  return window.em && window.em.checkJsApi("dingCreate");
};

// ding
export const createDing = (params, sucessCallback, failCallback) => {
  callApi("/api/ec/dev/app/test", "GET", {}).then(res => {
    const corpId = res.em_corpid;
    window.em.dingCreate({
      corpId,
      ...params,
      success: function(res) {
        if (sucessCallback && typeof sucessCallback === "function") {
          sucessCallback(res);
        }
      },
      fail: function(err) {
        message.error(err);
        if (failCallback && typeof failCallback === "function") {
          failCallback(err);
        }
      }
    });
  });
};



// WEBPACK FOOTER //
// ./ecology9/wea-tools/emTools.js